import {Box, Skeleton, Theme} from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

import {Delivery} from '../../../Finance/Invoices/Delivery.types'
import {Order} from '../../Order.types'
import {VariationCodeBanner} from '../../components/VariationCodeBanner'
import {hasVariationCode, isTopBannerCode} from '../../variationCode.utils'

import { ContactDetailsField } from './ContactDetailsField'
import { DeliveryAnnotationField } from './DeliveryAnnotationField'
import { MainOrderDetails } from './MainOrderDetails'

interface OrderDetailsProps {
  order?: Order
  deliveries?: Delivery[]
  isFetching: boolean
  deliveriesWithNotesCount?: number
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr'
    }
  },
  rightColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    borderLeft: '1px solid rgb(232, 236, 240)',
    paddingLeft: 16,
  }
}))

export const OrderDetails: React.FC<OrderDetailsProps> = ({ order, deliveries, isFetching, deliveriesWithNotesCount = 0 }) => {
  const { classes } = useStyles()

  const totalDeliveries = deliveries?.length ?? 0

  if (isFetching) return <Skeleton variant="rectangular" height={200} />

  return (
    <>
      {order && hasVariationCode(order) && isTopBannerCode(order.variationCode!) && (
        <Box mb={2}>
          <VariationCodeBanner order={order} placement="top" />
        </Box>
      )}
      <div className={classes.container}>
      <MainOrderDetails order={order} deliveries={deliveries} />
      <div className={classes.rightColumnContainer}>
        {order?.contactInformation && (
          <ContactDetailsField siteContact={order?.contactInformation} />
        )}
        <DeliveryAnnotationField deliveriesWithNotes={deliveriesWithNotesCount} totalDeliveries={totalDeliveries} />
      </div>
    </div>
    </>
  )
}
